import React from 'react';
import { Link } from 'react-router-dom';

import BasePage from '../BasePage';
import Navigation from '../../../components/Site/Navigation';
import Footer from '../../../components/Site/Footer';

class NotFound extends BasePage {
	render() {
		return (
			<div>
				<div className="section section--centered section--full-height bg--purple">
					<Navigation />
					<h1>Oops.</h1><br />
					<p>
						We can’t find that page,<br />
						at least not right meow.<br /><br />
						<Link className="site-link" to="/">Go to Tabby Home</Link>
					</p>
				</div>
				<Footer bgColor="bg--purple" />
			</div>
		);
	}
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/routes/Site/NotFound/index.js